import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  id: "modal-content",
  class: "flex-container"
}
const _hoisted_3 = {
  id: "modal-inner",
  class: "non-scrollable"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "modal-buttons"
}

import { ModalResult } from '@/types/ModalResult';
import { computed, ref } from '@vue/reactivity';



export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    clickCloses: {type: Boolean, default: false},
    showCloseButton: {type: Boolean, default: true},
    closeOnButtonClick: {type: Boolean, default: true},
    title: {type: String, default: "title"},
    message: {type: String, default: ""},
    button1msg: {type: String, default: ""},
    button2msg: {type: String, default: ""},
    button1type: {type: String, default: "primary"},
    button2type: {type: String, default: "danger"},
},
  emits: ["closed","clicked1","clicked2"],
  setup(__props, { expose, emit }) {

const props = __props;

const isShown = ref(false);




const anyButtonEnabled = computed(() => {
    return (props.button1msg.length>0 || props.button2msg.length>0);
});


function show(){
    isShown.value = true;
}

let resolveShow: ((value: ModalResult | PromiseLike<ModalResult>) => void)|null = null;

function showAsync():Promise<ModalResult>{
    show();
    return new Promise(function(resolve, reject){
        console.log("promise created");
        resolveShow = resolve;
    });
}
function close(){
    isShown.value = false;
    if(resolveShow!=null)
        resolveShow(ModalResult.Cancel);
    emit("closed");
}
expose({
  show,
  close,
  showAsync
});

function btn1clicked(){
    if(props.closeOnButtonClick)
        isShown.value = false;

    emit("clicked1");
    if(resolveShow!=null)
        resolveShow(ModalResult.Button1);
}
function btn2clicked(){
    if(props.closeOnButtonClick)
        isShown.value = false;

    emit("clicked2");
    if(resolveShow!=null)
        resolveShow(ModalResult.Button2);
}
function clickedOutside(){
    if(props.clickCloses){
        close();
    }
}
function closeBtnClick(){
    close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(isShown))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "modal-main",
          onClick: _withModifiers(clickedOutside, ["self"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, [
              _renderSlot(_ctx.$slots, "icon"),
              _createTextVNode(" " + _toDisplayString(__props.title), 1)
            ]),
            (__props.showCloseButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-close",
                  onClick: closeBtnClick
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              (__props.message)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.message), 1))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "default")
            ]),
            (_unref(anyButtonEnabled))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (__props.button1msg.length>0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["btn", ['btn-'+__props.button1type]]),
                        onClick: btn1clicked
                      }, _toDisplayString(__props.button1msg), 3))
                    : _createCommentVNode("", true),
                  (__props.button2msg.length>0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass(["btn", ['btn-'+__props.button2type]]),
                        onClick: btn2clicked
                      }, _toDisplayString(__props.button2msg), 3))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})